function isInternalMockUrlParam(name) {
    return (name.startsWith("b_feature_") ||
        name.startsWith("exp_") ||
        name === "my_ip" ||
        name === "i_am_from" ||
        name === "i_fly_from" ||
        name === "show_tags" ||
        name === "debug" ||
        name === "mock-scenario-name" ||
        name === "mock-scenario-enabled" ||
        name === "force-payment-error");
}
export function getInternalMockUrlParams(search) {
    const result = {};
    new URLSearchParams(search).forEach((value, name) => {
        if (isInternalMockUrlParam(name)) {
            result[name] = value;
        }
    });
    return result;
}
export function createUrlWithInternalMockUrlParams(url, currentSearch) {
    const relativeUrlBase = "http://x";
    const urlObj = new URL(url, relativeUrlBase);
    const params = getInternalMockUrlParams(currentSearch);
    Object.keys(params).forEach((key) => {
        urlObj.searchParams.set(key, params[key]);
    });
    return urlObj.toString().replace(relativeUrlBase, "");
}
